import axios from "axios";
import originalJSONP from "jsonp";
import Promise from "promise";
window.Promise = Promise;
axios.defaults.timeout = 5000;
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
// axios.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";

export const getFetch = async (url, params = {}) => {
  try {
    const response = await new Promise((resolve, reject) => {
      axios
        .get(url, { params: params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return response;
  } catch (e) {
    return {
      code: -1,
      message: e.message,
      status: false,
    };
  }
};

export const postFetch = async (url, params = {}) => {
  try {
    const response = await new Promise((resolve, reject) => {
      axios
        .post(url, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return response;
  } catch (e) {
    return e.message;
  }
};

export const jsonp = async (url, data, option) => {
  url += (url.indexOf("?") < 0 ? "?" : "&") + param(data);
  try {
    const response = await new Promise((resolve, reject) => {
      originalJSONP(url, option, (err, data) => {
        if (!err) {
          resolve(data);
        } else {
          reject(err);
        }
      });
    });
    return response;
  } catch (e) {
    return e.message;
  }
};

function param(data) {
  let url = "";
  for (var k in data) {
    let value = data[k] !== undefined ? data[k] : "";
    url += `&${k}=${encodeURIComponent(value)}`;
  }
  return url ? url.substring(1) : "";
}
